import { render } from "./TipTapToolbar.vue?vue&type=template&id=2a1795dc"
import script from "./TipTapToolbar.vue?vue&type=script&lang=js"
export * from "./TipTapToolbar.vue?vue&type=script&lang=js"

import "./TipTapToolbar.vue?vue&type=style&index=0&id=2a1795dc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__